import React, { useState } from 'react'
import { connect } from 'react-redux'
import FormInput from './FormInput'
import Button from './Button'
import Spinner from './Spinner'
import { getPromocode, postSubscriptionsPromocode, getAccount } from '../actions/api'
import { setDiscounts } from '../actions/utils'
import SubscriptionExtraTipPrice from './SubscriptionExtraTipPrice'
import get from 'lodash/get'
import usePromocodeLogic from '../utils/usePromocodeLogic'

import '../styles/promocode.scss'

function Promocode({
  getPromocode,
  postSubscriptionsPromocode,
  getAccount,
  setDiscounts,
  activeSubscriptionTypes,
  subscriptions,
  newSubscriptionEl,
  extraTipCents,
  setExtraTipCents
}) {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [errors, setErrors] = useState([])
  const [promocode, setPromocode] = useState('')

  const { applyPromocode, viewEl } = usePromocodeLogic({
    promocode,
    setPromocode,
    setErrors,
    setLoading,
    getPromocode,
    activeSubscriptionTypes,
    subscriptions,
    setDiscounts,
    newSubscriptionEl,
    postSubscriptionsPromocode,
    getAccount,
    setSuccess
  })

  return (
    <div className="account-promocode" ref={viewEl}>
      <div className="account-promocode__title account-promocode__title--only-mobile">ЕСТЬ ПРОМОКОД?</div>
      {errors && errors.length > 0 && (
        <div className="account-promocode__error-message">
          {errors.map((item, index) => (
            <p key={index}>{get(item, 'title')}</p>
          ))}
        </div>
      )}
      <form className="account-promocode__form" onSubmit={handleSubmit}>
        <div className="account-promocode__price-input">
          <FormInput
            label={renderLabel()}
            className="account-promocode__input-wrap"
            classNameContainer="account-promocode__input-container"
            classNameInput="account-promocode__input"
            value={promocode}
            onChange={handleInputChange}
          />
          <Button className="account-promocode__button" disabled={loading} type="submit">
            {loading ? <Spinner /> : 'Применить'}
          </Button>
        </div>
        <SubscriptionExtraTipPrice
          {...{
            extraTipCents,
            setExtraTipCents
          }}
        />
      </form>
    </div>
  )

  async function handleSubmit(event) {
    event.preventDefault()
    await applyPromocode(promocode)
  }

  function handleInputChange(event) {
    return setPromocode(event.target.value)
  }

  function renderLabel() {
    if (success) {
      return (
        <>
          <span className="account-promocode__title account-promocode__title--only-desktop">ЕСТЬ ПРОМОКОД?</span>
          Ура! Всё получилось!
        </>
      )
    } else {
      return (
        <>
          <span className=" account-promocode__title account-promocode__title--only-desktop">ЕСТЬ ПРОМОКОД?</span>
          Введите его скорее!
        </>
      )
    }
  }
}

export default connect(null, { postSubscriptionsPromocode, getPromocode, getAccount, setDiscounts })(
  React.memo(Promocode)
)
